import { gql } from '@apollo/client'

export const SEND_REFERRAL_EMAIL = gql`
  mutation AP_SendReferralEmail($patientId: ID!, $referralId: ID!) {
    sendReferralEmail(patientId: $patientId, referralId: $referralId)
  }
`
